import { BrowserModule } from '@angular/platform-browser';

import { NgModule, ApplicationRef, ComponentFactoryResolver, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Kept App component to include multiple components in future based on attribute passed on app-root element
import { AppComponent } from './app.component';

import { BookingWidgetComponent } from './booking-widget/booking-widget.component';
import { WidgetSearchComponent } from './common/widget-search/widget-search.component';
import { DatePickerComponent } from './common/date-picker/date-picker.component';
import { GuestSelectionComponent } from './booking-widget/guest-selection/guest-selection.component';
import { ScandicNumberInputComponent } from './common/scandic-number-input/scandic-number-input.component';

@NgModule({
  // bootstrap: [ BookingWidgetComponent ],  // change to App Component when multiple components are used.
  declarations: [
    AppComponent,
    BookingWidgetComponent,
    WidgetSearchComponent,
    DatePickerComponent,
    GuestSelectionComponent,
    ScandicNumberInputComponent,
  ],
  entryComponents: [ BookingWidgetComponent ],
  imports: [
    // BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserModule.withServerTransition(
      { appId: 'xena-static' }
    ),
  ],
  providers: [],
})
export class AppModule {

  constructor(private resolver: ComponentFactoryResolver) {
    if (typeof(document) != 'undefined') {
      document.body.classList.add('ng-ready');
    }
  }

  ngDoBootstrap(appRef: ApplicationRef) {
    // Donot add any components which are included/referred into the component which is already bootstrapping.
    [BookingWidgetComponent].forEach((componentDef: Type<{}>) => {
      const factory = this.resolver.resolveComponentFactory(componentDef);
      if (document.querySelector(factory.selector)) {
          appRef.bootstrap(factory);
      }
    });
  }
}
